const AppColor = {
    mainColor: '#035781',
    secondColor: '#f0f2f5'
}

export default AppColor